import { obterDispositivo } from './obterDispositivo';

/**
 * Configuração das conversões para Google Ads e Facebook Pixel.
 */
const CONVERSOES = {
    CADASTRO_CURRICULO: {
        googleAds: 'AW-16835762258/0SodCMm0_LkbENKw9ds-',
        googleEvent: 'lead_cadastro_cv',
        facebookEvent: 'Lead cadastro cv'
    },
    CANDIDATURA_VAGA: {
        googleAds: 'AW-16835762258/pRG6CM_Lrr4bENKw9ds-',
        googleEvent: 'lead_candidato_vaga',
        facebookEvent: 'Lead candidato vaga'
    }
};

/**
 * Dispara evento de conversão para Google Ads e Facebook Pixel.
 * @param {object} conversao - Objeto de configuração da conversão.
 */
function _dispararConversao(conversao) {
    if (typeof gtag === 'function') {
        gtag('event', 'conversion', { 'send_to': conversao.googleAds });
        gtag('event', conversao.googleEvent);
    }

    if (typeof fbq === 'function') {
        fbq('trackCustom', conversao.facebookEvent);
    }
}

/**
 * Dispara evento de conversão para novo cadastro de currículo.
 */
export function trackConversaoCadastroCurriculo() {
    _dispararConversao(CONVERSOES.CADASTRO_CURRICULO);
}

/**
 * Dispara evento de conversão para nova candidatura a vaga.
 */
export function trackConversaoCandidaturaVaga() {
    _dispararConversao(CONVERSOES.CANDIDATURA_VAGA);
}

/**
 * Insere um novo track de evento.
 * @param {string} name - Nome do evento.
 * @param {object} data - Informação do evento.
 */
export function addTrack(name, data = {}) {
    if (!window.mixpanel) {
        return;
    }
    if (data == null || data == undefined) { data = {}; }

    const hotSiteEmpresaID = document.getElementById("hotSiteEmpresaID");
    const hotSiteUrl = document.getElementById('hotSiteUrl');
    if (hotSiteEmpresaID != undefined && hotSiteUrl != undefined)
    {
        data.empresaID = hotSiteEmpresaID.value;
        data.hotsite = hotSiteUrl.value;
    }
    else {
        data.hotsite = 'empregare';
    }
    data.dispositivo = obterDispositivo();

    mixpanel.track(name, data);
}